import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Interface_getQueryStringObject extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_interface_getquerystringobject">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Interface.getQueryStringObject</h2>
              <p>
                NL.Interface.getQueryString is a method that allows you to get a
                the querystring with all its variables as an object in the
                Nexoid Application.
              </p>
              <WorkflowCompatibility front={true} back={false} />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Interface.getQueryStringObject Example</h2>
              <p>
                This example gets all variables in the querystring as an object.
              </p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">value</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Interface</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">getQueryStringObject</span>
                  <span className="jsonY">(</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Interface_getQueryStringObject;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Interface_getQueryStringObject.js